import { defineStore } from 'pinia'
import { ws, connect as wsConnect } from '@/socket'

export const useConnectionStore = defineStore('connection', {
  state: () => ({
    isConnected: false,
  }),

  actions: {
    // bindEvents() {},

    // connect(roomId) {},

    subscribe(userId, roomId) {
      if (ws.readyState === 1) {
        ws.close()
      }
      const channelId = roomId === 'new' ? `newchat_${userId}` : roomId
      wsConnect(channelId)
    },
  },
})
